/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import server from '../_api/backend';
import * as toast from '../_store/slice/toast';

export function FindAccount(props: RouteComponentProps) {
  const [idfindSwitch, setIdfindSwitch] = useState<boolean>();
  const [nameText, setNameText] = useState<string>('');
  const [usernameText, setUsernameText] = useState<string>('');
  const [emailText, setEmailText] = useState<string>('');
  const [searchSwitch, setSearchSwitch] = useState<boolean>(true);
  const [phone1, setPhone1] = useState<string>('');
  const [phone2, setPhone2] = useState<string>('');
  const [phone3, setPhone3] = useState<string>('');
  const dispatch = useDispatch();

  const findUsernameParam = {
    email: emailText,
    name: nameText,
  };

  const findPasswordParam = {
    username: usernameText,
    email: emailText,
    phone: `${phone1}-${phone2}-${phone3}`,
  };

  // 취소 버튼 클릭 시
  const onClickCancel = () => {
    props.history.push('/login');
  };

  // 계정 찾기 버튼 클릭 시
  const onClickFind = async () => {
    if (idfindSwitch === undefined || idfindSwitch === null) {
      dispatch(
        toast.error({
          message: '아이디 또는 비밀번호 찾기 중 하나를 선택해주세요.',
          title: '필수 선택 항목 누락',
        })
      );
      return;
    }
    if (nameText.length <= 0 && idfindSwitch === true) {
      dispatch(toast.error({ message: '이름을 작성해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (usernameText.length <= 0 && idfindSwitch === false) {
      dispatch(toast.error({ message: '아이디를 작성해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (
      (phone1.length === 0 || phone2.length === 0 || phone3.length === 0) &&
      idfindSwitch === false
    ) {
      dispatch(
        toast.error({ message: '휴대폰 번호를 작성해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (emailText.length <= 0) {
      dispatch(toast.error({ message: '이메일을 작성해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (idfindSwitch === true) {
      try {
        setSearchSwitch(false);
        await server.postFindUsername(findUsernameParam).then((payload1) => {
          if (payload1) {
            dispatch(toast.info({ message: '찾으시는 아이디를 이메일로 전송하였습니다.' }));
            setSearchSwitch(true);
            props.history.push('/login');
          }
        });
      } catch (error) {
        setSearchSwitch(true);
        console.log(error);
      }
    } else {
      try {
        setSearchSwitch(false);
        await server.postFindPassword(findPasswordParam).then((payload2) => {
          if (payload2) {
            dispatch(toast.info({ message: '찾으시는 비밀번호를 이메일로 전송하였습니다.' }));
            setSearchSwitch(true);
            props.history.push('/login');
          }
        });
      } catch (error) {
        setSearchSwitch(true);
        console.log(error);
      }
    }
  };

  // Find_Account 리턴값
  return (
    <main className="sub find-account wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>아이디/비밀번호 찾기</>
        </div>
        <div className="title">
          <h2>아이디/비밀번호 찾기</h2>
        </div>
        <div className="flex-container">
          <section>
            <h3>아이디 찾기</h3>
            <div>
              <input
                type="radio"
                id="byEmail"
                name="getYourAccount"
                onClick={() => setIdfindSwitch(true)}
              />
              <label htmlFor="byEmail">이메일로 아이디 찾기</label>
              <small>회원가입 시 작성한 정보와 아래의 입력한 정보가 일치해야 합니다.</small>

              <ul className="inputs">
                <li>
                  <span className="required">이름</span>
                  <input
                    type="text"
                    value={nameText}
                    onChange={(event) => setNameText(event.target.value)}
                  />
                </li>
                <li className="email">
                  <span className="required">이메일</span>
                  <div>
                    <input
                      type="email"
                      value={emailText}
                      onChange={(event) => setEmailText(event.target.value)}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <section>
            <h3>비밀번호 찾기</h3>
            <div>
              <input
                type="radio"
                id="byID"
                name="getYourAccount"
                onClick={() => setIdfindSwitch(false)}
              />
              <label htmlFor="byID">이메일로 비밀번호 찾기</label>
              <small>회원가입 시 작성한 정보와 아래의 입력한 정보가 일치해야 합니다.</small>
              <ul className="inputs">
                <li className="get-id">
                  <span className="required">아이디</span>
                  <input
                    type="text"
                    value={usernameText}
                    onChange={(event) => setUsernameText(event.target.value)}
                  />
                </li>
                <li className="phone">
                  <span className="required">휴대폰 번호</span>
                  <div>
                    <input
                      type="number"
                      value={phone1}
                      onChange={(event) => {
                        setPhone1(event.target.value);
                      }}
                    />
                    <span>-</span>
                    <input
                      type="number"
                      value={phone2}
                      onChange={(event) => {
                        setPhone2(event.target.value);
                      }}
                    />
                    <span>-</span>
                    <input
                      type="number"
                      value={phone3}
                      onChange={(event) => {
                        setPhone3(event.target.value);
                      }}
                    />
                  </div>
                </li>
                <li className="email">
                  <span className="required">이메일</span>
                  <div>
                    <input
                      type="email"
                      value={emailText}
                      onChange={(event) => setEmailText(event.target.value)}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
        <div className="buttons">
          <button className="btn-sub" onClick={onClickCancel}>
            취소
          </button>
          {searchSwitch === true ? (
            <button className="btn-main" onClick={onClickFind}>
              계정 찾기
            </button>
          ) : (
            <button className="btn-main">계정 찾는 중</button>
          )}
        </div>
      </div>
    </main>
  );
}
